<template>
  <div class="smc">
    <div class="smc-container">
      <h3 class="smc-title">
        {{ title }}
      </h3>
      <div>
<!--        <Button class="btn-outline-tertiary btn-sm">-->
<!--          Edit-->
<!--        </Button>-->
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
// import Button from '@/components/Button/Button.vue';

export default {
  name: 'SummarizationCard',
  components: {
    // Button,
  },
  props: {
    title: {
      type: String,
    },
  },
};
</script>
